import { Directive, Input } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PropertiesSettings } from "../../core/configuration/properties-settings";
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { MappingTipiEntitaFascicolo } from '../configuration/mapping-tipi-entita-fascicolo';
import { Legale } from '../models/legale';
import { Parte } from '../models/parte';
import { AmbitoCompetenza } from '../models/tipologiche/ambito-competenza';
import { Comune } from '../models/tipologiche/comune';
import { Materia } from "../models/tipologiche/materia";
import { Provincia } from '../models/tipologiche/provincia';
import { SoggettoPratica } from "../models/tipologiche/soggetto-pratica";
import { TipoPersona } from '../models/tipologiche/tipo-persona';
import { TipoSocieta } from '../models/tipologiche/tipo-societa';
import { TipoTipologica } from "../models/tipologiche/tipo-tipologica";
import { FormValidationService } from '../services/form-validation.service';
import { BaseForm } from './base-Form';

declare var removeEmptyObject: any;

@Directive()
export abstract class AnagraficaForm extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  provinceOptions: Provincia[] = [];
  comuniNascitaOptions: Comune[] = [];
  comuniResidenzaOptions: Comune[] = [];
  ambitiCompetenzaOptions: AmbitoCompetenza[] = [];
  tipoPersonaOptions: TipoPersona[] = [];
  request: Legale | Parte;
  anagraficaForm: FormGroup;
  sessoSelected:boolean=true;
  tipisocietaOptions: SoggettoPratica[] = [];
  tipicontrattoOptions: TipoTipologica[] = [];
  tipidipendenteOptions: TipoTipologica[] = [];
  figureprofessionaliOptions: TipoTipologica[] = [];
  statidipendenteOptions: TipoTipologica[] = [];
  materieOptions: Materia[] = [];
  profiliOptions: TipoTipologica[] = [];
  tipiSocieta: TipoSocieta[] = [];
  dataToday: number = new Date().getTime();
  @Input() isLegali: boolean = false;
  @Input() isControparte: boolean = false;
  @Input() isControparti: boolean = false;
  idTipoFascicolo:string;
  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected formValidationService: FormValidationService) {
    super();
  }

  populateSelect() {
    if (this.tipisocietaOptions.length === 0) {
      console.log(this.getTipoPratica());
      this.helpers.getSoggetti().subscribe(response => {
        if (PropertiesSettings.PRATICHE_CON.includes(this.getTipoPratica())) {
          this.tipisocietaOptions = response.filter(el => el.sigla !== 'CD');
        } else if (PropertiesSettings.PRATICHE_CD.includes(this.getTipoPratica())) {
          this.tipisocietaOptions = response.filter(el => el.sigla !== 'CON');
        } else {
          this.tipisocietaOptions = response;
        }
      });
    }
    if (this.provinceOptions.length === 0) {
      this.helpers.getProvince().subscribe(response => this.provinceOptions = response);
    }
    if (this.tipoPersonaOptions.length === 0) {
      this.helpers.getTipiPersona().subscribe(response => this.tipoPersonaOptions = response);
    }
    if (this.tipiSocieta.length === 0) {
      this.helpers.getTipiSocieta().subscribe(response => this.tipiSocieta = response);
    }
    if (this.tipidipendenteOptions.length === 0) {
      this.helpers.getTipiDipendente().subscribe(response => this.tipidipendenteOptions = response);
    }
    if (this.statidipendenteOptions.length === 0) {
      this.helpers.getTipiStatiDipendente().subscribe(response => this.statidipendenteOptions = response);
    }
    if (this.profiliOptions.length === 0) {
      this.helpers.getProfili().subscribe(response => this.profiliOptions = response);
    }
    if (this.hasAmbitiCompetenza() && this.ambitiCompetenzaOptions.length === 0) {
      this.helpers.getAmbitiCompetenza().subscribe(response => this.ambitiCompetenzaOptions = response);
    }
    this.getFiguraProfessionale();
  }

  changeProvinciaNascita(idProvincia: string) {
    this.helpers.getCittaByProvincia(idProvincia).subscribe(response => this.comuniNascitaOptions = response);
  }

  changeProvinciaResidenza(idProvincia: string) {
    this.helpers.getCittaByProvincia(idProvincia).subscribe(response => this.comuniResidenzaOptions = response);
  }

  getTipiContrattoBySocieta(idSocieta) {
    this.helpers.getContrattiBySocieta(idSocieta).subscribe(response => this.tipicontrattoOptions = response);
  }

  getFiguraProfessionaleByTipoContratto(idTipoContratto) {
    this.helpers.getFigureProfessionaliByContratto(idTipoContratto).subscribe(response => this.figureprofessionaliOptions = response);
  }

  getFiguraProfessionale() {
    if (this.figureprofessionaliOptions.length === 0) {
      this.helpers.getFigureProfessionali().subscribe(response => this.figureprofessionaliOptions = response.tipologiche);
    }
  }
  isFascicoloSanitario():boolean{
    return !!(this.idTipoFascicolo && this.idTipoFascicolo === MappingTipiEntitaFascicolo.FASCICOLO_SINISTRO_SANITARIO);
  }
  createForm() {
    this.request = this.getAdapter();
    if (this.request.provinciaNascita && this.request.provinciaNascita.id !== '-1') {
      this.changeProvinciaNascita(this.request.provinciaNascita.id);
    }

    if (this.request.provinciaResidenza && this.request.provinciaResidenza.id !== '-1') {
      this.changeProvinciaResidenza(this.request.provinciaResidenza.id);
    }


    this.anagraficaForm = this.campiForm.group({
      nome: [this.request.nome, Validators.compose([this.formValidationService.lettere])],
      cognome: [this.request.cognome],
      tipoPersona: [this.request.tipoPersona, Validators.required],
      codiceFiscale: [this.request.codiceFiscale, Validators.compose([this.formValidationService.codiceFiscale])],
      sesso:[this.sessoSelected],
      vivente:[this.request.vivente],
      dipendente: [this.request.dipendente],
      matricola: [this.request.matricola, Validators.compose([this.formValidationService.numeri])],
      societa: [this.request.societa],
      ragioneSociale: [this.request.ragioneSociale, Validators.compose([this.formValidationService.longString])],
      partitaIva: [this.request.partitaIva, Validators.compose([this.formValidationService.partitaIva])],
      codiceFiscaleRappresentanteLegale: [this.request.codiceFiscaleRappresentanteLegale, Validators.compose([this.formValidationService.codiceFiscaleRappresentanteLegale])],
      tipoSocieta: [this.request.tipoSocieta],
      dataNascita: [this.request.dataNascita],
      provinciaNascita: [this.request.provinciaNascita],
      comuneNascita: [this.request.comuneNascita],
      indirizzo: [this.request.indirizzo],
      cap: [this.request.cap, Validators.compose([this.formValidationService.cap])],
      provinciaResidenza: [this.request.provinciaResidenza],
      comuneResidenza: [this.request.comuneResidenza],
      telefono: [this.request.telefono, Validators.compose([this.formValidationService.telefono])],
      cellulare: [this.request.cellulare, Validators.compose([this.formValidationService.telefono])],
      fax: [this.request.fax, Validators.compose([this.formValidationService.telefono])],
      email: [this.request.email, Validators.compose([this.formValidationService.email])],
      pec: [this.request.pec, Validators.compose([this.formValidationService.email])],
      tipoContratto: [this.request.tipoContratto],
      //tipoDipendente: [this.request.tipoDipendente],
      figuraProfessionale: [this.request.figuraProfessionale],
      unitaOrganizzativaAppartenenza: [this.request.unitaOrganizzativaAppartenenza],
      unitaorganizzativautilita: [this.request.unitaorganizzativautilita],
      statoDipendente: [this.request.statoDipendente],
      dataAssunzione: [this.request.dataAssunzione],
      dataCessazione: [this.request.dataCessazione],
      note: [this.request.note],
      albo: [this.request.albo],
      numeroIscrizione: [this.request.numeroIscrizione],
      codiceMeccanografico: [this.request.codiceMeccanografico]
    });

    if ('nominativoOriginale' in this.request) {
      this.anagraficaForm.addControl('nominativoOriginale', this.campiForm.control(this.request.nominativoOriginale));
      console.log('Valore nominativoOriginale: ' + this.request.nominativoOriginale);
    }
    /*if (this.hasConvenzione()) {
      this.anagraficaForm.addControl('convenzione', new FormControl((<Legale>this.request).convenzione));
    }

    if (this.hasTariffa()) {
      this.anagraficaForm.addControl('tariffa', new FormControl((<Legale>this.request).tariffa, Validators.compose([this.formValidationService.decimali])));
    }*/
    /*if(this.isControparte){
      this.anagraficaForm.controls['albo'].setValidators([Validators.required]);
      this.anagraficaForm.controls['albo'].updateValueAndValidity();
    }else{
      this.anagraficaForm.controls['albo'].setValidators([]);
      this.anagraficaForm.controls['albo'].updateValueAndValidity();
    }*/
    this.setDefaultSesso();
    if (this.hasAmbitiCompetenza()) {
      this.anagraficaForm.addControl('ambitiCompetenza', new UntypedFormControl((<Legale>this.request).ambitiCompetenza));
    }
  }

  changedDipendente(event) {
    if (event) {
      // this.anagraficaForm.controls['societa'].setValidators([Validators.required]);
      // this.anagraficaForm.controls['matricola'].setValidators([Validators.required]);
      this.getFiguraProfessionale();
    } else {
      // this.anagraficaForm.controls['societa'].clearValidators();
      // this.anagraficaForm.controls['matricola'].clearValidators();
      this.request.matricola = null;
      this.request.tipoContratto = null;
      //this.request.tipoDipendente = null;
      this.request.figuraProfessionale = null;
      this.request.unitaOrganizzativaAppartenenza = null;
      this.request.unitaorganizzativautilita = null;
      this.request.statoDipendente = null;
    }
    // this.anagraficaForm.controls['societa'].updateValueAndValidity();
    // this.anagraficaForm.controls['matricola'].updateValueAndValidity();
  }

  anagraficaValidator() {
    let result = false;
    if (this.request &&
     //this.request.codiceFiscale &&
      ((this.formValidationService.personaFisica(this.request.nome, this.request.cognome, this.request.codiceFiscale, this.request.tipoPersona)
//       && this.request.codiceFiscale
       )
       ||   this.formValidationService.personaGiuridica(this.request.ragioneSociale, this.request.partitaIva, this.request.tipoPersona))) {
      result = true;
    }
    return result;
  }

  changeTipoPersona(tipoPersona: TipoPersona){
    if(tipoPersona == null){
         // Reset di tutti i campi obbligatori legati a tipoPersona
      this.anagraficaForm.get('nome').setValue(null);
      this.anagraficaForm.get('cognome').setValue(null);
      this.anagraficaForm.get('codiceFiscale').setValue(null);
      this.anagraficaForm.get('ragioneSociale').setValue(null);
      this.anagraficaForm.get('partitaIva').setValue(null);

      this.anagraficaForm.controls["nome"].setValidators([]);
      this.anagraficaForm.controls["cognome"].setValidators([]);
      this.anagraficaForm.controls["sesso"].setValidators([]);
      this.anagraficaForm.controls["ragioneSociale"].setValidators([]);
      this.anagraficaForm.controls["codiceFiscale"].setValidators([]);
      this.anagraficaForm.controls["partitaIva"].setValidators([]);
    }
    else if(tipoPersona.label=='FISICA'){
      this.onChangeSesso(true);
      this.anagraficaForm.controls['sesso'].setValidators([Validators.required]);
      this.request.vivente = true;
      this.anagraficaForm.get('ragioneSociale').setValue(null);
      this.anagraficaForm.get('partitaIva').setValue(null);

      this.anagraficaForm.controls["nome"].setValidators([Validators.required,this.formValidationService.lettere]);
      this.anagraficaForm.controls["cognome"].setValidators([Validators.required,this.formValidationService.lettere]);
      this.anagraficaForm.controls["codiceFiscale"].setValidators([Validators.required,this.formValidationService.codiceFiscale]);
      this.anagraficaForm.controls["sesso"].setValidators([Validators.required]);
      this.anagraficaForm.controls["ragioneSociale"].setValidators([]);
      this.anagraficaForm.controls["partitaIva"].setValidators([]);
    }
    else if(tipoPersona.label=='GIURIDICA'){
      this.request.sesso=null;
      this.request.vivente=null;
      this.anagraficaForm.controls['sesso'].setValidators([]);
      this.anagraficaForm.get('nome').setValue(null);
      this.anagraficaForm.get('cognome').setValue(null);
      this.anagraficaForm.get('codiceFiscale').setValue(null);

      this.anagraficaForm.controls["nome"].setValidators([]);
      this.anagraficaForm.controls["cognome"].setValidators([]);
      this.anagraficaForm.controls["sesso"].setValidators([]);
       this.anagraficaForm.controls["codiceFiscale"].setValidators([]);
      this.anagraficaForm.controls["ragioneSociale"].setValidators([Validators.required]);
      this.anagraficaForm.controls["partitaIva"].setValidators([Validators.required]);
    }

    this.anagraficaForm.controls["nome"].updateValueAndValidity();
    this.anagraficaForm.controls["cognome"].updateValueAndValidity();
    this.anagraficaForm.controls["codiceFiscale"].updateValueAndValidity();
    this.anagraficaForm.controls["sesso"].updateValueAndValidity();
    this.anagraficaForm.controls["ragioneSociale"].updateValueAndValidity();
    this.anagraficaForm.controls["partitaIva"].updateValueAndValidity();
  }

  onChangeSesso(event){
    this.sessoSelected = event;
    this.request.sesso = (!!event) ? 'M' : 'F';
  }

  setDefaultSesso(){
    if (this.request.sesso =='M' ) {
      this.sessoSelected=true;
    }
    else if(this.request.sesso =='F') {
      this.sessoSelected=false;
    }
  }

  update() {
    this.getRequest(this.request);
  }

  abstract getAdapter(): Legale | Parte;
  abstract getRequest(request: Legale | Parte);
  abstract hasConvenzione(): boolean;
  abstract hasTariffa(): boolean;
  abstract hasAmbitiCompetenza(): boolean;
  abstract getTipoPratica(): any;
}
